<template>
  <i class="fas fa-times close-modal" @click="$modal.hide(modalName)"></i>
</template>
<script>
export default {
  props: ['modalName']
}
</script>
<style scoped>
.close-modal {
  float: right !important;
  cursor: pointer !important;
  width: 1rem;
  color: #686f7a;
}
</style>
